import { TransactionFieldConfig, TransactionFormConfig } from "./types";

// ─── Wspólne pola ────────────────────────────────────────────────────────────

const currencyField: TransactionFieldConfig = {
  name: "currencyUuid",
  label: "Waluta",
  type: "select",
  placeholder: "Wybierz walutę",
  required: true,
};

const fileField: TransactionFieldConfig = {
  name: "file",
  label: "Umowa",
  type: "file",
  accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
  required: false,
};


const defaultFields: TransactionFieldConfig[] = [
  // typeField,
  // quantityField,
  // unitPriceField,
  // totalValueField,
  // currencyField,
  // completedAtField,
  // noteField,
  // fileField,
];

export const getTransactionFormConfig = (slug: string, type?: string, currencyCode?: string): TransactionFormConfig => {
  if (slug === "treasury_bonds") {
    const isSell = type === "sell";
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: isSell
            ? "Ilość sprzedanych Obligacji Skarbowych"
            : "Ilość kupionych Obligacji Skarbowych",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "totalValue",
          label: isSell
            ? "Wartość sprzedanych Obligacji Skarbowych"
            : "Wartość kupionych Obligacji Skarbowych",
          type: "number",
          placeholder: "",
          required: false,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "unitPrice",
          label: "Wartość jednej obligacji skarbowej",
          type: "computed",
          computeValues: (values) => {
            const qty = Number(values.quantity);
            const total = Number(values.totalValue);
            if (!qty || !total || qty === 0) return "";
            return (total / qty).toLocaleString("pl-PL", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        },
        {
          name: "completedAt",
          label: isSell ? "Data sprzedaży" : "Data transakcji",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }
  if (slug === "crypto" && type === "sell") {
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: "Ilość sprzedanych Tokenów/Kryptowalut",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "completedAt",
          label: "Data sprzedaży",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }
if (slug === "precious_stones" && type === "sell") {
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: "Masa sprzedanych kamieni szlachetnych",
          type: "number",
          placeholder: "",
          required: true,
          suffix: "g",
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "totalValue",
          label: "Kwota zakupu",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "completedAt",
          label: "Data sprzedaży",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }

  if (slug === "precious_metals") {
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: type === "sell" ? "Masa sprzedanych metali szlachetnych" : "Masa",
          type: "number",
          placeholder: "",
          required: true,
          suffix: "g",
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "totalValue",
          label: "Cena zakupu",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        currencyField,
        {
          name: "completedAt",
          label: type === "sell" ? "Data sprzedaży" : "Data transakcji",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }

  if (slug === "currencies") {
    const isSell = type === "sell";
    return {
      slug,
      fields: [
        {
          name: "totalValue",
          label: isSell ? "Ilość sprzedanych walut" : "Ilość kupionych walut",
          type: "number",
          placeholder: "",
          suffix: currencyCode || undefined,
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "unitPrice",
          label: isSell ? "Kurs sprzedaży" : "Kurs zakupu",
          type: "number",
          placeholder: "",
          required: false,
          step: "any",
          precision: 4,
          maxLength: 12,
        },
        {
          name: "acquisitionCost",
          label: "Koszt nabycia:",
          type: "computed",
          computeValues: (values) => {
            const qty = parseFloat(String(values.quantity));
            const rate = parseFloat(String(values.unitPrice));
            if (!isNaN(qty) && !isNaN(rate) && qty > 0 && rate > 0) {
              return (qty * rate).toLocaleString("pl-PL", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
            }
            return "";
          },
        },
        {
          name: "completedAt",
          label: "Data transakcji",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }

  return { slug, fields: defaultFields };
};

